








import { Component, Vue, Watch } from "vue-property-decorator";
import VLargeRadio, { LargeRadioItem } from "@/components/VLargeRadio.vue";
import { currentScoutingStore } from "@/store/typed";
import { AnalysisState } from "@/models/Scouting";
import AreaCollapsableList from "./AreaCollapsibleList.vue";
import ScoutingPlaceCollapsableList from "./ScoutingPlaceCollapsibleList.vue";
import StoreSubscriber from "@/utils/StoreSubscriber";
import GroupCollapsableList from "@/components/Analysis/GroupCollapsableList.vue";

@Component({
  components: {
    VLargeRadio,
    AreaCollapsableList,
    ScoutingPlaceCollapsableList,
    GroupCollapsableList,
  },
})
export default class Sidebar extends Vue {
  radioItems: LargeRadioItem[] = [
    {
      id: "report",
      text: "Riepilogo analisi",
    },
    {
      id: "national",
      text: "Mezzi nazionali",
    },
  ];
  radioActive: LargeRadioItem | null = null;
  poiOpen = false;
  areaOpen = false;
  groupOpen = false;
  private functionStatusChanged = new Function();

  mounted() {
    const analysis = currentScoutingStore.scoutingAnalysis;
    this.subscribe();
    if (analysis) {
      this.loadStatus(analysis.status);
    }
  }
  destroyed() {
    this.functionStatusChanged();
  }

  loadStatus(status: AnalysisState | null) {
    if (status) {
      if (status == AnalysisState.Brief) {
        this.radioActive = this.radioItems[0];
        return;
      } else if (status == AnalysisState.National) {
        this.radioActive = this.radioItems[1];
        return;
      } else if (status == AnalysisState.POI) {
        this.poiOpen = true;
      } else if (status == AnalysisState.Area) {
        this.areaOpen = true;
      } else if (status == AnalysisState.Group) {
        this.groupOpen = true;
      }
    }
    this.radioActive = null;
  }

  storeStatusChanged(status: AnalysisState) {
    this.loadStatus(status);
  }

  subscribe() {
    this.functionStatusChanged = StoreSubscriber.subscribe(
      "currentScouting/$changeScoutingAnalysisState",
      this.storeStatusChanged.bind(this)
    );
  }

  @Watch("radioActive")
  onRadioActiveChanged(value: LargeRadioItem | null) {
    if (value && value.id === "report") {
      currentScoutingStore.changeScoutingAnalysisState(AnalysisState.Brief);
    } else if (value && value.id === "national") {
      currentScoutingStore.changeScoutingAnalysisState(AnalysisState.National);
    }
  }
}
